import React from 'react';
import Picture from 'Shared/Picture';

const ArticleReviewer = (review) => (
    <div className="article-section-reviewer">
        <div className="wrapper">
            <Picture
                className="reviewerImage"
                src={review.ReviewerImage.Value}
                alt={review.ReviewerImageAlt.Value}
                mobileWidth={80}
                mobileHeight={80}
            />
            <div className="description">
                <div className="first-line" dangerouslySetInnerHTML={{"__html": review.FirstLineText.Value}} />
                <div className="name">
                    {review.ReviewerUrl.Value !== '' ? (
                        <a href={review.ReviewerUrl.Value}>{review.ReviewerName.Value}</a>
                    ) : (
                        <span>{review.ReviewerName.Value}</span>
                    )}
                </div>
                <div className="second-line" dangerouslySetInnerHTML={{"__html": review.SecondLineText.Value}} />
            </div>
        </div>
        {review.ReviewerLogo.Value[0] !== null && (
            <div className="logo">
                <Picture src={review.ReviewerLogo.Value} alt={review.ReviewerLogoAlt.Value} />
            </div>
        )}
    </div>
);
export default ArticleReviewer;
